import React from 'react';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette, spacing }) => ({
    track: {
        position: 'absolute',
        height: 5,
        zIndex: 1,
        background: palette.secondary.main,
        borderRadius: spacing(0.25),
        cursor: 'pointer',
    },
}));
export function Track({ source, target, getTrackProps, key, }) {
    const classes = useStyles();
    return (React.createElement("div", { key: key, className: classes.track, style: {
            left: `${source.percent}%`,
            width: `${target.percent - source.percent}%`,
        }, ...getTrackProps() }));
}
//# sourceMappingURL=Track.js.map